import { Link } from 'react-router-dom';

export default function VisualCtaSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-14">
          <div className="w-full h-56 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20workspace%20desk%20with%20large%20monitor%20showing%20colorful%20data%20dashboard%2C%20tablet%20displaying%20spreadsheet%2C%20coffee%20cup%2C%20notebook%2C%20and%20small%20potted%20succulent%2C%20bright%20natural%20light%20from%20large%20window%2C%20clean%20organized%20desk%2C%20productive%20tech%20lifestyle%2C%20warm%20and%20inviting%20atmosphere&width=1200&height=700&seq=visual-cta-v2&orientation=landscape"
              alt="Mulebuy spreadsheet workspace"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/15"></div>
          </div>
        </div>

        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug max-w-2xl mx-auto">
          Start Using <span className="italic">Verified</span> Mulebuy
          <br />
          Spreadsheet Today
        </h2>

        <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mt-5 leading-relaxed">
          Get access to updated mulebuy spreadsheet lists and compare trusted agents instantly. All data is verified weekly for accuracy and reliability.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3.5 rounded-full bg-foreground-950 text-white text-sm font-semibold cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            Go to Main Platform
          </a>
          <Link
            to="/what-is-mulebuy-spreadsheet"
            className="px-7 py-3.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium cursor-pointer hover:border-foreground-400 transition-colors whitespace-nowrap"
          >
            Read Full Guide
          </Link>
        </div>

        <p className="text-xs text-foreground-400 mt-4 whitespace-nowrap">
          New spreadsheets added weekly — outdated lists removed
        </p>
      </div>
    </section>
  );
}